// Endpoint specs:
// https://www.dropbox.com/scl/fi/31nxogj0nap0jy842z4sg/Payment-Page.paper?dl=0&rlkey=sx4z963m428xpb3tpar5sb92y#:uid=259258728448306139937439&h2=Endpoint:-Make-a-payment

const pendingResponse = {
  success: true,
  paymentStatus: "processing",
};

const successResponse = {
  success: true,
  paymentStatus: "completed",
  amount: 2000, // in cents
  receiptSentTo: "hello@example.com", // null if no email on file and no receipt sent
};

const failedResponse = {
  isApp: false,
  paymentStatus: "declined",
  // paymentStatus: "unknownfailure",
  // paymentStatus: "rejectedasfraud",
  paymentDeclinedReasonCode: "INSUFFICIENT_FUNDS",
  receiptSentTo: "foster154@gmail.com",
  success: true,
  userID: 12357242,
};

export const createMockPollingPaymentResponse = () => {
  const rando = Math.floor(Math.random() * 5); // 0 - 4

  if (rando === 0) {
    return failedResponse;
  } else if (rando === 1) {
    return successResponse;
  } else {
    return pendingResponse;
  }

  // return successResponse;
  // return failedResponse;
  // return pendingResponse;
};
